import { render, staticRenderFns } from "./NavWeb.vue?vue&type=template&id=7155289c&scoped=true&"
import script from "./NavWeb.vue?vue&type=script&lang=js&"
export * from "./NavWeb.vue?vue&type=script&lang=js&"
import style0 from "./NavWeb.vue?vue&type=style&index=0&id=7155289c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7155289c",
  null
  
)

export default component.exports